import styles from "./checkout.module.css";

const STEPS = ["Summary", "Your details", "Payment", "Done"];
const STEP_INDEX = {
  summary: 0,
  details: 1,
  verifying: 2,
  success: 3,
  error: 2,
};

const StepIndicator = ({ currentStep }) => {
  const stepIndex = STEP_INDEX[currentStep] ?? 0;

  return (
    <div className={styles.steps}>
      {STEPS.map((label, i) => {
        const done = i < stepIndex;
        const active = i === stepIndex;
        return (
          <div key={label} className={styles.stepWrap}>
            <div className={styles.stepCol}>
              <div
                className={`${styles.stepDot} ${done ? styles.done : ""} ${active ? styles.active : ""}`}
              >
                {done ? "✓" : i + 1}
              </div>
              <span
                className={`${styles.stepLabel} ${active ? styles.active : ""}`}
              >
                {label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={`${styles.stepLine} ${done ? styles.done : ""}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;
